export const waitUntil = async (checkFunction: () => boolean, interval = 10, maxTry = 100): Promise<void> => {
	await new Promise<void>((resolve, reject) => {
		const check = (count: number): void => {
			setTimeout(() => {
				if (count > maxTry) {
					reject(new Error('Max try reached'))
				} else if (checkFunction()) {
					resolve()
				} else {
					check(count + 1)
				}
			}, interval)
		}

		check(0)
	})
}
